var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishedStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "active_diamond",
    "data-name": "active diamond",
    transform: "translate(-29 -204)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2411",
    "data-name": "Rectangle 2411",
    width: 40,
    height: 40,
    rx: 10,
    transform: "translate(29 204)",
    fill: "#ffcfe9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "diamond",
    transform: "translate(37 196.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5243",
    "data-name": "Path 5243",
    d: "M23.853,68.492,19.985,63.71a.665.665,0,0,0-.517-.246H4.532a.665.665,0,0,0-.517.246L.147,68.492a.66.66,0,0,0,0,.832L11.132,82.793h0l.187-2.146L13.6,81.893h0l3.6-4.42L20.447,73.5l3.4-4.175a.66.66,0,0,0,0-.832Z",
    transform: "translate(0 -44.563)",
    fill: "#e5caf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5244",
    "data-name": "Path 5244",
    d: "M11,82.792l1.034-.687,1.405-.212h0L3.311,69.324a.666.666,0,0,1,0-.832L7.131,63.71a.654.654,0,0,1,.511-.246H4.478a.654.654,0,0,0-.511.246L.145,68.492a.666.666,0,0,0,0,.832Z",
    transform: "translate(0 -44.563)",
    fill: "#cb97e7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910",
    transform: "translate(0 18.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_119_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5245",
    "data-name": "Path 5245",
    d: "M3.968,68.518,7,73.674H.1l-.1,0a.654.654,0,0,1,.145-.415Z",
    transform: "translate(-0.001 -68.274)",
    fill: "#9857bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5246",
    "data-name": "Path 5246",
    d: "M3.312,73.259,5.3,70.789,3.969,68.517,2.863,69.889.147,73.259a.654.654,0,0,0-.142.349v.01c0,.01,0,.02,0,.03s0,.017,0,.026H0l.1,0H3.166A.655.655,0,0,1,3.312,73.259Z",
    transform: "translate(-0.002 -68.273)",
    fill: "#814aa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5247",
    "data-name": "Path 5247",
    d: "M353.592,74.478a.655.655,0,0,1,.145.413h-6.946l2.957-5.035.072-.059h0Z",
    transform: "translate(-329.737 -69.492)",
    fill: "#9857bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5248",
    "data-name": "Path 5248",
    d: "M154.426,175.137l-3.979,13.678-.424.522a.656.656,0,0,1-1.018,0l-.349-.429-1.909-6.563-1.69-5.809-.407-1.4Z",
    transform: "translate(-137.514 -169.58)",
    fill: "#cb97e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5249",
    "data-name": "Path 5249",
    d: "M194.554,340.438l.342-1.177-3.9-4.8,1.764,6.066.349.429a.651.651,0,0,0,.285.2.66.66,0,0,0,.448,0,.651.651,0,0,0,.285-.2Z",
    transform: "translate(-181.631 -321.202)",
    fill: "#bd80e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5250",
    "data-name": "Path 5250",
    d: "M284.29,63.774l-.072.059-2.957,5.035-3.33-5.4h5.8a.656.656,0,0,1,.511.244Z",
    transform: "translate(-264.271 -63.468)",
    fill: "#af66da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5251",
    "data-name": "Path 5251",
    d: "M275.431,175.137h.005a.654.654,0,0,1-.147.412l-3.364,4.141-3.2,3.942-4.211,5.183,3.979-13.678Z",
    transform: "translate(-251.436 -169.58)",
    fill: "#bd80e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5252",
    "data-name": "Path 5252",
    d: "M264.853,433.66l-.342,1.177.649-.8Z",
    transform: "translate(-251.563 -415.601)",
    fill: "#af66da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5253",
    "data-name": "Path 5253",
    d: "M151.1,63.468l3.33,5.4h-9.775l3.33-5.4Z",
    transform: "translate(-137.514 -63.468)",
    fill: "#d9b1ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5254",
    "data-name": "Path 5254",
    d: "M88.4,63.468l-3.33,5.4-3.028-5.156a.656.656,0,0,1,.511-.244Z",
    transform: "translate(-78.009 -63.468)",
    fill: "#bd80e1"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5255",
    "data-name": "Path 5255",
    d: "M85.714,63.468H82.552a.656.656,0,0,0-.511.244l1.334,2.271,1.83-2.271A.656.656,0,0,1,85.714,63.468Z",
    transform: "translate(-78.018 -44.567)",
    fill: "#9857bd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedStep);
export default __webpack_public_path__ + "static/media/finished_step.bcec54200e212a88b3c9f5ebaf580e93.svg";
export { ForwardRef as ReactComponent };